import React, { useEffect } from 'react';
import { v4 as uuid } from 'uuid';
import { BrowserRouter as Router, Switch, useLocation, useHistory } from 'react-router-dom';
import { PrivateRoute } from '@Components/';
import { NotFoundPage } from '@Local/Error/';
import routerMap from '@Router/router';
import {
    ENTRANCE_MEMBER_ROOT_ROUTER,
    ENTRANCE_EMPLOYEE_ROOT_ROUTER, EMPLOYEE_MEASURE_RESULT_ROUTER, MEMBER_PROFILE_ROUTER
} from '@Router/routerPath';
import MainLayout from '@Local/Components/Layout/MainLayout';
import { getIsAndroid, localUser } from '@Util/utils';
import { MEMBER_SITE_LOGON_TYPE } from "@Constants/";

const checkRootPath = (root, pathname) => {
    const regExpString = new RegExp(`^/${root}[/]?$`);
    return regExpString.test(pathname);
};

const Main = (props) => {
    const { path: rootPath } = props;
    let { pathname } = useLocation();
    let history = useHistory();

    const { logonType } = localUser.get() || {};

    useEffect(
        () => {
            if (logonType === MEMBER_SITE_LOGON_TYPE.MEMBER && checkRootPath(ENTRANCE_MEMBER_ROOT_ROUTER, pathname))
                history.push(MEMBER_PROFILE_ROUTER);
            else if (logonType === MEMBER_SITE_LOGON_TYPE.EMPLOYEE && checkRootPath(ENTRANCE_EMPLOYEE_ROOT_ROUTER, pathname))
                history.push(EMPLOYEE_MEASURE_RESULT_ROUTER);
        },
        // eslint-disable-next-line
        [pathname],
    );

    return (
        <MainLayout>
            <Switch>
                {routerMap.map(({ path: pathRouter, exact, as: Component, ...others }) => {
                    if (!pathRouter) return null;
                    const defaultProperty = {
                        path: pathRouter,
                        exact,
                        as: Component,
                        ...others,
                    };
                    return <PrivateRoute key={uuid()} {...defaultProperty} />;
                })}
                <PrivateRoute path={`${rootPath}/404`} as={NotFoundPage} />
                <PrivateRoute path="*" as={NotFoundPage} />
            </Switch>
        </MainLayout>
    );
};

const LandingPage = (props) => {
    useEffect(
        () => {
            if (getIsAndroid()) {
                document.body.classList.add('mobile');
            }
        },
        // eslint-disable-next-line
        [],
    );

    return (
        <Router>
            <Main />
        </Router>
    );
};

export default LandingPage;
